import '../../../assets/markdown.css'

import startsWith from 'lodash/startsWith'
import PropTypes from 'prop-types'
import React from 'react'
import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'

function setHeaderStyle(level) {
  switch (level) {
    case 1:
      return 'text-4xl'
    case 2:
      return 'text-3xl'
    case 3:
      return 'text-2xl'
    case 4:
      return 'text-xl'
    case 5:
      return 'text-lg'
    case 6:
      return 'text-3xl'
    default:
      return 'text-base'
  }
}

function MarkdownQuestionRendererFC({ value }) {
  return (
    <ReactMarkdown
      className="markdown-question text-gray-700"
      plugins={[gfm]}
      renderers={{
        list: ({ ordered, ...props }) =>
          ordered ? (
            <ol className="list-decimal pl-4">{props.children}</ol>
          ) : (
            <ul className="list-disc pl-4">{props.children}</ul>
          ),
        heading: ({ level, ...props }) => (
          <p className={`font-medium ${setHeaderStyle(level)}`} {...props} />
        ),
        paragraph: (props) => <p className="py-2" {...props} />,
        link: ({ href, children, ...props }) => {
          const pathToGo = startsWith(href, 'http') ? href : `https://${href}`
          return (
            <a
              className="font-medium text-zentake"
              href={pathToGo}
              rel="noopener noreferrer"
              target="_blank"
              {...props}
            >
              {children}
            </a>
          )
        },
      }}
    >
      {value}
    </ReactMarkdown>
  )
}

MarkdownQuestionRendererFC.propTypes = {
  value: PropTypes.string.isRequired,
}

function areEqual(p, n) {
  return p.value === n.value
}

const MarkdownQuestionRenderer = React.memo(
  MarkdownQuestionRendererFC,
  areEqual
)

export default MarkdownQuestionRenderer
